"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Langs = void 0;
var Langs;
(function (Langs) {
    Langs["PL"] = "pl";
    Langs["EN"] = "en";
    Langs["CS"] = "cs";
    Langs["DE"] = "de";
    Langs["ES"] = "es";
    Langs["FR"] = "fr";
    Langs["IT"] = "it";
    Langs["NL"] = "nl";
    Langs["RU"] = "ru";
    Langs["SK"] = "sk";
    Langs["UK"] = "uk";
})(Langs = exports.Langs || (exports.Langs = {}));
